export default __webpack_public_path__ + "static/media/third-party-data-consent-kr-0.c60075e8.jpg";